"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const styles_1 = require("@material-ui/core/styles");
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const Done_1 = __importDefault(require("@material-ui/icons/Done"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const prop_types_1 = __importDefault(require("prop-types"));
const totangoTheme_1 = require("../../theme/totangoTheme");
const input_1 = __importDefault(require("../input/input"));
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    nested: {
        paddingLeft: theme.spacing(4),
    },
    listItem: {
        paddingTop: 3,
        paddingBottom: 3,
    },
    listItemText: {
        fontSize: '13px',
    },
}));
const getOpenedTreeItems = (tree, selectedItem) => {
    const result = [];
    const getTreeItem = (item) => {
        if (item.key === selectedItem.key || (!!item.items && item.items.some(getTreeItem))) {
            result.push(item);
            return true;
        }
        return false;
    };
    tree.some(getTreeItem);
    return result;
};
const renderIcon = (item) => {
    if (item.iconClass) {
        return react_1.default.createElement("i", { className: item.iconClass });
    }
    if (item.iconComponent) {
        return item.iconComponent;
    }
    return react_1.default.createElement("i", { className: "material-icons" }, item.icon);
};
const TreeViewItem = ({ item, onSelect, children, selected, open, autoExpand, isAddingNewOption, newFolderName, onNewFolderNameChange, onClearNewFolderClick, onAddFolderSubmit, onNewFolderNameEnter, addFolderValidationError, }) => {
    const isSelected = selected && selected.key === item.key;
    const isExpandable = item.items && item.items.length > 0 && (autoExpand || !isSelected);
    const classes = useStyles();
    const [isOpen, setIsOpen] = (0, react_1.useState)(open);
    const handleItemClick = (0, react_1.useCallback)(() => {
        if (isExpandable) {
            setIsOpen(!isOpen);
        }
        onSelect(item);
    }, [isExpandable, setIsOpen, onSelect, isOpen, item]);
    const shouldShowNewOptionInput = isAddingNewOption && isSelected;
    return (react_1.default.createElement(core_1.List, { disablePadding: true, className: "tree-list" },
        react_1.default.createElement(core_1.ListItem, { button: true, onClick: handleItemClick, selected: isSelected, className: `${classes.listItem} tree-list-item` },
            react_1.default.createElement(core_1.ListItemIcon, { className: "item-icon" }, renderIcon(item)),
            react_1.default.createElement(core_1.ListItemText, { primary: item.value, classes: { primary: classes.listItemText }, className: "item-name" }),
            isExpandable
                && (isOpen ? (react_1.default.createElement("i", { className: "material-icons arrow-icon" }, "keyboard_arrow_down")) : (react_1.default.createElement("i", { className: "material-icons" }, "keyboard_arrow_right")))),
        shouldShowNewOptionInput && (react_1.default.createElement(core_1.ListItem, { className: "tree-add-new-item" },
            react_1.default.createElement(input_1.default, { autoFocus: true, error: !!addFolderValidationError, helperText: addFolderValidationError, type: "text", variant: "outlined", className: "edit-item-input", value: newFolderName, onChange: onNewFolderNameChange, onKeyDown: onNewFolderNameEnter, endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end", className: "end-adornment" },
                    react_1.default.createElement(IconButton_1.default, { className: "save-new-item", "aria-label": "save folder", onClick: onAddFolderSubmit, edge: "end" },
                        react_1.default.createElement(Done_1.default, null)),
                    react_1.default.createElement(IconButton_1.default, { className: "cancel-new-item", "aria-label": "cancel", onClick: onClearNewFolderClick, edge: "end" },
                        react_1.default.createElement(Clear_1.default, null)))), startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start", className: "start-adornment" },
                    react_1.default.createElement("i", { className: "material-icons" }, "folder"))) }))),
        isExpandable && (react_1.default.createElement(core_1.Collapse, { in: isOpen, timeout: "auto", unmountOnExit: true, className: `${classes.nested} collapsable-element` }, children))));
};
const NestedItems = ({ items, selected, onSelect, openedItems = [], autoExpand, newFolderName, isAddingNewOption, onNewFolderNameChange, onClearNewFolderClick, onAddFolderSubmit, onNewFolderNameEnter, addFolderValidationError, }) => (react_1.default.createElement(react_1.default.Fragment, null, (0, sortBy_1.default)(items, (item) => item?.value?.toLowerCase()).map((item) => (react_1.default.createElement(TreeViewItem, { item: item, onSelect: onSelect, key: item.key, selected: selected, open: openedItems && openedItems.includes(item), autoExpand: autoExpand, newFolderName: newFolderName, isAddingNewOption: isAddingNewOption, onNewFolderNameChange: onNewFolderNameChange, onClearNewFolderClick: onClearNewFolderClick, onAddFolderSubmit: onAddFolderSubmit, onNewFolderNameEnter: onNewFolderNameEnter, addFolderValidationError: addFolderValidationError }, item?.items?.length > 0 && (react_1.default.createElement(NestedItems, { items: item.items, selected: selected, onSelect: onSelect, openedItems: openedItems, autoExpand: autoExpand, newFolderName: newFolderName, isAddingNewOption: isAddingNewOption, onNewFolderNameChange: onNewFolderNameChange, onClearNewFolderClick: onClearNewFolderClick, onAddFolderSubmit: onAddFolderSubmit, onNewFolderNameEnter: onNewFolderNameEnter, addFolderValidationError: addFolderValidationError })))))));
const TreeView = ({ options, onSelect, selectedItem, ignoreSameSelection, autoExpand = true, newFolderName, isAddingNewOption, onNewFolderNameChange, onClearNewFolderClick, onAddFolderSubmit, onNewFolderNameEnter, addFolderValidationError, }) => {
    const [selected, setSelected] = (0, react_1.useState)(selectedItem);
    const openedItems = selectedItem && getOpenedTreeItems(options, selectedItem);
    const onSelectHandle = (0, react_1.useCallback)((item) => {
        if (item !== selected || ignoreSameSelection) {
            setSelected(item);
            onSelect(item);
        }
    }, [setSelected, onSelect, selected, ignoreSameSelection]);
    return (react_1.default.createElement(styles_1.MuiThemeProvider, { theme: totangoTheme_1.totangoTheme },
        react_1.default.createElement(core_1.List, null,
            react_1.default.createElement(NestedItems, { items: options, selected: selected, onSelect: onSelectHandle, openedItems: openedItems, autoExpand: autoExpand, newFolderName: newFolderName, isAddingNewOption: isAddingNewOption, onNewFolderNameChange: onNewFolderNameChange, onClearNewFolderClick: onClearNewFolderClick, onAddFolderSubmit: onAddFolderSubmit, onNewFolderNameEnter: onNewFolderNameEnter, addFolderValidationError: addFolderValidationError }))));
};
exports.default = TreeView;
TreeView.defaultProps = {
    selectedItem: undefined,
};
const treeItemShape = prop_types_1.default.shape({
    key: prop_types_1.default.any.isRequired,
    value: prop_types_1.default.string.isRequired,
    icon: prop_types_1.default.string,
    iconClass: prop_types_1.default.string,
    iconComponent: prop_types_1.default.element,
});
TreeView.propTypes = {
    options: prop_types_1.default.arrayOf(treeItemShape).isRequired,
    onSelect: prop_types_1.default.func.isRequired,
    selectedItem: treeItemShape,
};
//# sourceMappingURL=tree-view.js.map